<template>
  <div :class="`navlinks-wrap ${style}`">
    <router-link
      v-for="(item, index) in links"
      :key="index"
      :to="`${item.path === 'home'? `/${$i18n.locale}`:`/${$i18n.locale}/${item.path}` }`"
      class="link-green"
      >{{ t(`navBar.navItems.${item.path}`) }}
    </router-link>
    <!-- <ResumeButton /> --->
    <LinkedinButton />
  </div>
</template>

<script>
// import TitlePath from "./../views/titlePath";
import {useI18n} from 'vue-i18n';
import LinkedinButton from './linkedinButton.vue';
// import ResumeButton from './resumeButton';
export default {
  name: "NavLinks",
  components: {
    // ResumeButton,
    LinkedinButton
  },
  props: {
    links: Object,
    style: String
  },
  setup() {
    const {t} = useI18n();
    return {t}
  }
};
</script>

<style>
.navlinks-wrap {
  font-family: var(--font-sans);
  font-size: var(--text-xs);
  display: flex;
  align-items: center;
  gap: var(--space-4);
}

@media (min-width: 768px) {
  .navlinks-wrap {
    gap: var(--space-8);
    font-size: var(--text-base);
  }
}
</style>
